
import React, {FC, useEffect, useState, Fragment} from 'react';
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import { Auth } from './services/auth';
import { Login } from './components/login';
import { Nomatch } from './components/common/nomatch';
import { App } from './components/app';


const Main: FC<{}> = () => {
    return ( <BrowserRouter>
       <Switch>
           <Route exact path="/">
             <Login></Login>
           </Route>
           <ProtectedRoute>
             <App></App>
           </ProtectedRoute>
           <Route path="*">
             <Nomatch></Nomatch>
           </Route>
         </Switch>
      </BrowserRouter>
      )
}

const ProtectedRoute: FC<{}> = ({children}) => {
  return <Route path="/app" render={({location}) => {
    return Auth.isLoggedIn() ? children : <SyncRoute>{children}</SyncRoute>
  }}>
    
  </Route>
}

const SyncRoute: FC<{}> = ({children}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [user, setUser] = useState<any|null>(null);
  useEffect(() => {
    const [sync] = Auth.sync(setUser, setLoading, setError);
    sync();
  }, []);
  if(loading){
    return <div className="sync-container">
      <h5>Sincronizzazione utente, attendere...</h5>
      <Spinner animation="border" variant="primary"></Spinner>
      </div>
  }
  if(error || user === null){
    return <Redirect to={{pathname: '/'}}></Redirect>;
  }
  return <Fragment>{children}</Fragment>;
}

export default Main;
